module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginForm modal fade",
    attrs: {
      "id": "bsModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(0), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "bsModalLabel"
    }
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n        "), (_vm.checkText) ? _c('div', [_c('div', {
    staticClass: "tree-content tree--small",
    staticStyle: {
      "padding": "10px 0px"
    },
    on: {
      "click": function($event) {
        _vm.isChecked = !_vm.isChecked
      }
    }
  }, [_c('i', {
    class: ['tree-checkbox', _vm.isChecked ? 'checked' : '']
  }), _vm._v(" "), _c('span', {
    staticClass: "tree-anchor",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('span', {
    staticClass: "tree-text",
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_vm._v(_vm._s(_vm.checkText))])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.confirmText),
      expression: "confirmText"
    }],
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cancelText),
      expression: "cancelText"
    }],
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a165859c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 742
// module chunks = 0